<template>
  <div
    ref="slider"
    :class="{ 'no-swipe': $slots.default && $slots.default.length === 1 }"
    class="slider-pro"
  >
    <div class="sp-slides">
      <slot />
    </div>
    <slot name="thumbnails" />
  </div>
</template>

<script>
import 'slider-pro'

export default {
  name: 'SliderPro',
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      slider: null
    }
  },
  async mounted () {
    if (!this.$slots.default || (this.$slots.default && this.$slots.default.length === 0)) return
    await this.$nextTick()
    if (this._isDestroyed || this._isBeingDestroyed) return
    // init
    this.getSlider().sliderPro(this.options)
    // save an instance
    this.slider = this.getSlider().data('sliderPro')
  },
  beforeDestroy () {
    this.destroy()
  },
  methods: {
    getSlider () {
      return global.$(this.$refs.slider)
    },
    destroy () {
      const $slider = this.getSlider()
      const sliderId = this.slider.uniqueId
      global.$(window).off('resize.' + sliderId)

      setTimeout(function () {
        $slider.sliderPro('destroy')
      }, 200)
    }
  }
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import '~utils';

.no-swipe .sp-slides {
  transform: translate3d(0px, 0px, 0px) !important;
}
</style>
